export const apiURL = process.env.REACT_APP_API_URL ?? 'https://api.stream.dromt.it/v1alpha1';
export const graphqlURL = process.env.REACT_APP_GRAPHQL_URI ?? "https://graphql.dromt.it/v1/graphql";
export const weatherURL = process.env.REACT_APP_WEATHER_URI ?? "https://weather.dromt.it/";
export const version = process.env.REACT_APP_VERSION ?? 'dev';

export const iOSPWABottomPadding = 35;
export const iOSPWABottomBarHeight = 56;

export const gtmId = process.env.REACT_APP_GTM_ID ?? 'GTM-XXXXXX';
